import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Calendar } from '../../../components/Calendar'
import { validDateParam } from '../../../components/Calendar/calendarUtils'

export const Route = createFileRoute('/_authenticated/calendar/')({
  component: RouteComponent,
  // The viewed date (YYYY-MM-DD). Absent means today, so plain links to /calendar open on today.
  validateSearch: (search: Record<string, unknown>): { date?: string } => ({
    date: validDateParam(search.date),
  }),
})

function RouteComponent() {
  return (
    <>
      <div className="flex-1 px-4 sm:px-6 lg:px-8 pb-20 sm:pb-8">
        <Calendar />
      </div>
      <Outlet />
    </>
  )
}
